import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { getData, IMG_URL } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
  } = useForm();

  const imageFile = watch("image");

  // -------- Fetch existing data --------
  const GetEditData = async () => {
    const response = await getData(`/admin/masters/ourcustomersays/${id}`);
    reset(response?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  // -------- Submit Updated Data --------
  const onSubmit = async (data) => {
    try {
      const finalData = new FormData();
      finalData.append("name", data?.name);
    //   finalData.append("subname", data?.subname);
      finalData.append("rating", data?.rating);
      finalData.append("message", data?.message);

      if (data.image && data.image.length > 0) {
        finalData.append("image", data.image[0]);
      }

      const response = await putData(`/admin/masters/ourcustomersays/${id}`, finalData);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response?.data });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }

      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Our Customer Says</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Row>

              {/* -------- Name -------- */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Name</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Name"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Name is required",
                          maxLength: {
                            value: 200,
                            message: "Max 200 characters allowed",
                          },
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* -------- Sub Name -------- */}
              {/* <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Subname</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Subname"
                        className={classNames("", {
                          "is-invalid": errors?.subname,
                        })}
                        {...register("subname", {
                          required: "Subname is required",
                          maxLength: {
                            value: 200,
                            message: "Max 200 characters allowed",
                          },
                        })}
                      />
                    </InputGroup>
                    {errors.subname && (
                      <span className="text-danger">
                        {errors.subname.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col> */}

              {/* -------- Rating (1–5 only) -------- */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>Rating (1–5)</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="number"
                        placeholder="Rating"
                        className={classNames("", {
                          "is-invalid": errors?.rating,
                        })}
                        {...register("rating", {
                          required: "Rating is required",
                          min: { value: 1, message: "Minimum rating is 1" },
                          max: { value: 5, message: "Maximum rating is 5" },
                        })}
                      />
                    </InputGroup>
                    {errors.rating && (
                      <span className="text-danger">
                        {errors.rating.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* -------- message -------- */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Group>
                    <Form.Label>message</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="message"
                        className={classNames("", {
                          "is-invalid": errors?.message,
                        })}
                        {...register("message", {
                          required: "message is required",
                          maxLength: {
                            value: 200,
                            message: "Max 200 characters allowed",
                          },
                        })}
                      />
                    </InputGroup>
                    {errors.message && (
                      <span className="text-danger">
                        {errors.message.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {/* -------- Image Upload -------- */}
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Image</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="file"
                      accept=".jpg, .jpeg, .png, .webp"
                      {...register("image")}
                    />
                  </Form.Group>
                </div>
              </Col> 

              {/* -------- Image Preview -------- */}
               <Col md={6}>
                <div className="main-form-section mt-3">
                  <Form.Label>Preview</Form.Label>

                  {typeof getValues("image") === "string" ? (
                    <img
                      src={IMG_URL + getValues("image")}
                      alt="Preview"
                      className="image-preview"
                      style={{ maxWidth: "100px" }}
                    />
                  ) : (
                    imageFile &&
                    imageFile.length > 0 && (
                      <img
                        src={URL.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ maxWidth: "100px" }}
                      />
                    )
                  )}
                </div>
              </Col> 

              {/* -------- Buttons -------- */}
              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton name={"save"} handleSubmit={handleSubmit(onSubmit)} />
                </div>
              </Row>

            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;